import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FormControlValidators } from '@domgen/dgx-fe-forms/shared';
import { ArticleSearchForm } from '@self-fix/util-models';

@Injectable()
export class ArticleSearchFormComponentService {
  form!: FormGroup<ArticleSearchForm>;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router
  ) {}

  buildForm(): void {
    this.form = this.formBuilder.group<ArticleSearchForm>({
      search: this.formBuilder.control(
        null,
        Validators.compose([
          FormControlValidators.required(
            'Please input at least three letters to search'
          ),
          FormControlValidators.minimumLength(
            3,
            'Please input at least three letters to search'
          ),
        ])
      ),
    });
  }

  submit(term: string): void {
    this.router.navigate(['search'], { queryParams: { term } });
  }
}
